module.exports = __webpack_public_path__ + "img/off_rounded.d5907317.svg";